import moment from 'moment';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type momentReactValidator from 'js/lib/moment.validator';

import type { ModuleDeadline } from 'bundles/author-sessions/types/Session';

export const isModuleDeadlineValid = ({
  deadline,
  startedAt,
  endedAt,
}: {
  deadline: moment.Moment;
  startedAt: moment.Moment;
  endedAt: moment.Moment;
}): boolean => {
  return (
    moment(startedAt).valueOf() < moment(deadline).valueOf() && moment(deadline).valueOf() < moment(endedAt).valueOf()
  );
};

export const areAvailabilityDatesValid = ({
  unlockTime,
  relockTime,
  startedAt,
  endedAt,
}: {
  unlockTime: number;
  relockTime: number;
  startedAt: moment.Moment;
  endedAt: moment.Moment;
}) => {
  // If the item is meant to be locked for the whole session via a manual lock,
  // then we just say it's valid
  if (unlockTime === 0 && relockTime === 0) {
    return true;
  }

  const availabilityStart = moment(startedAt).add(unlockTime);

  const availabilityEnd = moment(startedAt).add(relockTime);

  return (
    availabilityStart.isBetween(startedAt, endedAt, 'minute', '[]') &&
    availabilityEnd.isBetween(startedAt, endedAt, 'minute', '[]') &&
    availabilityStart.isBefore(availabilityEnd)
  );
};

export const isSessionEndAtLeastWeekAfterModuleAndItemDeadlines = (
  moduleDeadlines: Array<ModuleDeadline>,
  endedAt: momentReactValidator,
  itemDeadlines?: Record<string, { deadline: number | moment.Moment }>,
  isWeekToModuleEnabledForCourse: boolean = false
) => {
  const lastModuleDeadline =
    moduleDeadlines && moment.max(moduleDeadlines.map((moduleDeadline) => moment(moduleDeadline.deadline)));

  const lastItemDeadline =
    // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    itemDeadlines && moment.max(Object.keys(itemDeadlines).map((itemId) => moment(itemDeadlines[itemId].deadline)));

  const maxDeadline =
    itemDeadlines && lastModuleDeadline && lastItemDeadline
      ? moment.max([lastModuleDeadline, lastItemDeadline])
      : lastModuleDeadline;

  // ignore module deadlines if week to module is enabled and there are no item deadlines since modules now replace weeks
  // and module deadlines no longer hold any functional meaning
  const ignoreModuleDeadlinesForSessionEnd = isWeekToModuleEnabledForCourse || !itemDeadlines;

  // Moment has a tendency to round-up with its diffing, so we're putting 10079 instead of 10080
  // to play it safe (where 10080 is the number of minutes in a week)
  return ignoreModuleDeadlinesForSessionEnd || moment(endedAt).diff(moment(maxDeadline), 'minutes') >= 10079;
};
// 1636354799438 - 1635749999438
export const isEnrollmentEndedAtValid = (
  enrollmentEndedAt: momentReactValidator,
  startedAt: momentReactValidator
): boolean => {
  return moment(startedAt).valueOf() < moment(enrollmentEndedAt).valueOf();
};

export const isSessionEndDateValid = (startedAt: momentReactValidator, endedAt: momentReactValidator): boolean => {
  return moment(startedAt).valueOf() < moment(endedAt).valueOf();
};

export const hasValidAvailabilityDates = ({
  startDate,
  endDate,
  itemDeadline,
}: {
  startDate: moment.Moment | undefined | null;
  endDate: moment.Moment | undefined | null;
  itemDeadline: moment.Moment | undefined | null;
}): boolean => {
  if (!itemDeadline) {
    // any dates are valid when there's no item deadline
    return true;
  } else if (
    (endDate && endDate.isBefore(itemDeadline, 'minute')) ||
    (startDate && startDate.isAfter(itemDeadline, 'minute'))
  ) {
    return false;
  }

  return true;
};
